module.exports = __webpack_public_path__ + "media/images/icons/magnifying-glass-2e440be8dbcf0988ba67adf3921cace5.svg";